import { render, staticRenderFns } from "./BaseFloatButton.vue?vue&type=template&id=6617e206&scoped=true"
import script from "./BaseFloatButton.vue?vue&type=script&lang=js"
export * from "./BaseFloatButton.vue?vue&type=script&lang=js"
import style0 from "./BaseFloatButton.vue?vue&type=style&index=0&id=6617e206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617e206",
  null
  
)

export default component.exports